module.exports = __webpack_public_path__ + "img/image-download.1ec210c4.jpg";